import { createAction } from '@reduxjs/toolkit';

import { AccountTypeDetails } from '@/types/api/account';
import { RequiredDocumentSection } from '@/types/document';
import { User } from '@/types/user';

export const setOperationData = createAction<{
  user: User;
  requiredSections: RequiredDocumentSection[];
  accountTypes: AccountTypeDetails[];
}>('operation-data/set-operation-data');

export const resetOperationData = createAction(
  'operation-data/reset-operation-data',
);

export const notifyMinorDataChanged = createAction(
  'operation-data/notify-minor-data-changed',
);

export const notifyMinorDataChangedSolved = createAction(
  'operation-data/notify-minor-data-changed-solved',
);
